<script>
import { defineComponent } from 'vue'
const name = 'InputTelefone'

export default defineComponent({
  name,

  components: {},
  emits: ['update:modelValue','invalido'],
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },

  mounted() {
    this.internalValue = this.modelValue
    this.maskChange()
  },

  updated() {},

  data() {
    return {
      internalValue: '',
      mascaraCelular: '(99) 99999-9999',
      mascaraTelefone: '(99) 9999-9999',
      mascaraVazia: '99999999999',
      mask: '99999999999',
      key: 0,
      hasValue: false,
      invalido:false,
    }
  },

  methods: {
    maskChange() {
      if (this.internalValue.length > 9) {
        this.mask = this.internalValue.length < 11 ? this.mascaraTelefone : this.mascaraCelular
        this.key++
        this.hasValue = true
        this.$emit('update:modelValue', this.internalValue)
        this.invalido = false
      }else{
        this.invalido = true
      }
      this.$emit('invalido', this.invalido )
      
    },

    forceInputMaskFocus() {
      setTimeout(() => {
        this.$refs.input.$el.focus()
      }, 100)
    },

    handleCleanMask() {
      if (this.internalValue.length === 0) {
        this.mask = this.mascaraVazia
        this.key++
        this.forceInputMaskFocus()
      }
    }
  },

  computed: {},

  watch: {
    modelValue(newValue) {
      /*eslint-disable*/
      this.internalValue = newValue
    },

    internalValue() {
      if(!this.hasValue){
        this.maskChange()
      }
    } 
  }
})
</script>

<template>
  <PInputMask
    ref="input"
    @update-modelValue="$emit('update:modelValue', $event)"
    :mask="mask"
    v-model="internalValue"
    placeholder="(99) 99999-9999"
    :autoClear="false"
    class="input"
    @blur="maskChange"
    :key="key"
    @keyup.backspace="handleCleanMask"
    unmask
    
    />
</template>

<style scoped>

</style>
